module.exports = __webpack_public_path__ + "static/media/no.1eb294a3.svg";